export const redtypes = {
    loadFabri: '[red]carga los fabricantes',
    loadZonas: '[red]carga las zonas',
    loadAutos: '[red]carga las autos',
    loadZones: '[red]carga las zonas de fibra',
    loadOlt: '[red]carga las olts de fibra',
    loadNaps: '[red]carga las cajas naps de fibra',
    loadMkts: '[red]carga los mikrotiks',
    loadIpv4: '[red]carga los ipv4',
    loadEmisores: '[red]carga los emisores',
    loadPlanes: '[red] load planes',
    loadPlanesFi: '[red] load planes de fibra',
    loadPerzo: '[red] load personalizados',
    planActivo: '[red] cargar el servicio activo',

    card1: '[DASBOARD] Tarjeta de transacciones',
    card2: '[DASBOARD] Tarjeta de instalciones',
    card3: '[DASBOARD] Tarjeta de tikets',
    resumen: '[DASBOARD] Resumen sistema',
    trafico: '[DASBOARD] Trafico del sistema',
    basicdash: ' [DASBOARD] funciones online,pagos,promise pays',
    resfin: '[DASBOARD] resumen finanzas',
    contracargos: '[DASBOARD] contracargos',

    loadRoles: '[red] cargar roles de  usuarios',
    loadTags: '[red] cargar tags',
    loadUsuarios: '[USUARIOS] cargar usuarios',
    loadAgentes: '[USUARIOS] cargar agentes',
    loadClientes: '[Clientes] cargar Clientes',

    idEmploye: '[EMPLOYES] cargar id del empleado para detalles',

    loadDash: '[DASBOARD] Cargar datos para el dashboard',
    loadSpeed: '[DASBOARD] Cargar datos para los speed graph',
    perm: '[DASBOARD] Permisos agentes',
    cerrarSesion: '[CLOSE] Cerrar sesión',
};
